export const A0: [number, number] = [2383.94, 3370.39];
export const A1: [number, number] = [1683.78, 2383.94];
export const A2: [number, number] = [1190.55, 1683.78];
export const A3: [number, number] = [841.89, 1190.55];
export const A4: [number, number] = [595.28, 841.89];
export const A5: [number, number] = [419.53, 595.28];
export const A6: [number, number] = [297.64, 419.53];
export const A7: [number, number] = [209.76, 297.64];
export const A8: [number, number] = [147.4, 209.76];
